import { IListApiRequest } from 'api/types'

export enum DOCUMENT_TYPES {
  PAYMENT_REMITTANCE = 'PAYMENT_REMITTANCE',
  PAYMENT_REMITTANCE_LINE_ITEM = 'PAYMENT_REMITTANCE_LINE_ITEM',
  INVOICE = 'INVOICE'
}

export interface thresholds {
  id?: string;
  fieldKey: string;
  minConfidenceScore: string;
  documentType: DocumentType;
}
export interface ThresholdsSaveRequest {
  thresholdsDTO: thresholds;
}
export interface ThresholdsListResponse {
  id?: string;
  totalElements?: number;
  content?: thresholds[];
  thresholdsDTO: thresholds;
}
export type ThresholdsListRequest = IListApiRequest<thresholds>
